import PropTypes from "prop-types";
import React from "react";

const TabPlaceholder = ({ name }) => (
  <div className="event-tab-placeholder">
    <p className="event-tab-placeholder-title">{name}</p>
    <p className="event-tab-placeholder-text">This section is coming soon.</p>
  </div>
);

TabPlaceholder.propTypes = { name: PropTypes.string.isRequired };

export default TabPlaceholder;
